import {
  Component, Input, OnInit, ViewContainerRef, ViewChild, ComponentRef,
  ChangeDetectorRef, ChangeDetectionStrategy, OnDestroy
 } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import * as _ from 'lodash';

import { segments } from '../../../segments-list';
import { DetailsSegment } from '../../../details-segment.interface';

import { DynamicComponentLoader } from 'shared/base/dynamic-component-loader.service';


@Component({
  moduleId: module.id,
  selector: 'scorecards-tab',
  templateUrl: 'scorecards-tab.component.html',
  styleUrls: ['scorecards-tab.component.scss'],
  providers: [DynamicComponentLoader],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ScorecardsTabComponent implements OnDestroy {

  // active scorecard component
  componentRef: ComponentRef<any>;
  completionOff: boolean = false;

  private isActive: boolean = true;

  @ViewChild('scorecardContainer', { read: ViewContainerRef, static: false })
  scorecardContainer: ViewContainerRef | void;

  constructor(
    private route: ActivatedRoute,
    private ref: ChangeDetectorRef,
    private dynamicComponentLoader: DynamicComponentLoader,
  ) {}

  /*******************************************
  * COMPONENT GETTERS
  *******************************************/

  get routeSegmentName(): string {
    return _.get(this.route.snapshot.params, 'segment', 'overview');
  }

  /*******************************************
  * COMPONENT HOOKS
  *******************************************/

  ngOnDestroy() {
    this.isActive = false;
    this.destroyScorecard();
  }

  /*******************************************
  * COMPONENT PUBLIC API
  *******************************************/

  /*
    * Sets data and scorecard name to the active scorecard
  */
  public updateData(data: any, scorecardName: string, itemDetail?: any, scorecardData?: any, priceSheets?: any): void {
    if (_.get(this.componentRef, 'instance')) {
      this.componentRef.instance.updateData(data, scorecardName, itemDetail, scorecardData, priceSheets);
    }
  }

  /*
    * Render scorecard component according on selected segment
  */
  public changeScorecard(
    segment: DetailsSegment|string,
    scoreData?: any,
    scorecardName?: string,
    itemDetail?: any,
    scorecardData?: any,
    priceSheets?: any,
    ) {
    if (_.isString(segment)) {
      segment = _.find(segments, ['name', segment]);
    }
    if (!segment) {
      console.warn('Segment not found');
      return;
    }
    const data = {};
    if (scoreData) { _.set(data, 'scoreData', scoreData); }
    if (scorecardName) { _.set(data, 'scorecardName', scorecardName); }
    if (itemDetail) { _.set(data, 'itemDetail', itemDetail); }
    if (scorecardData) { _.set(data, 'scorecardData', scorecardData); }
    if (priceSheets) { _.set(data, 'priceSheets', priceSheets); }
    this.renderScorecard(segment.scorecard, data);
  }

  public destroyScorecard(): void {
    this.dynamicComponentLoader.destroy();
    this.componentRef = null;
    this.ref.markForCheck();
  }

  public showCompletionOff(): void {
    this.completionOff = true;
    this.destroyScorecard();
  }

  /*******************************************
  * COMPONENT PRIVATE METHODS
  *******************************************/

  private renderScorecard(scorecardComponent: any, data: any): void {
    if (!scorecardComponent) {
      console.warn('Segment scorecard not found');
      return;
    }
    this.componentRef = null;
    this.componentRef = this.dynamicComponentLoader.load(
      scorecardComponent,
      this.scorecardContainer,
      data,
    );
    this.ref.markForCheck();
  }

}
